import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
// import axios from 'axios';
import { userObj } from "../../../../helper/protectedRoutes";
import axios from "../../../../api/axios";

const initialState = {
    orderDetails:[],
    isLoading:null,
    status:null,
}

const token = userObj?.token

export const getOrder = createAsyncThunk(
    'order/getOrder',
    async (id, {rejectWithValue}) => {
        
        try{
            const response = await axios.get(`/Order/${id}`,
            {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }
            )
            return response?.data
        } catch (err) {
            console.log(err.response)
            return rejectWithValue(err.response.data.title)
        }
        
    }
)

export const getOrderId = createAsyncThunk(
    'order/getOrderId',
    async (id, {rejectWithValue}) => {
        
        try{
            const response = await axios.get(`/Order/orderidbyno?no=${id}`,
            {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }
            )
            return response?.data
        } catch (err) {
            console.log(err.response)
            return rejectWithValue(err.response.data.title)
        }
        
    }
)

export const cancelOrder = createAsyncThunk(
    'order/cancelOrder',
    async (id, {rejectWithValue}) => {
        
        try{
            const response = await axios.get(`/Order/cancelOrder/${id}`,
            {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }
            )
            return response?.data
        } catch (err) {
            console.log(err.response)
            return rejectWithValue(err.response.data.title)
        }
        
    }
)

export const holdOrder = createAsyncThunk(
    'order/holdOrder',
    async (id, {rejectWithValue}) => {
        
        try{
            const response = await axios.get(`/Order/closeOrder/${id}`,
            {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }
            )
            return response?.data
        } catch (err) {
            console.log(err.response)
            return rejectWithValue(err.response.data.title)
        }
        
    }
)

export const resetOrder = createAsyncThunk(
    'order/resetOrder',
    async (id, {rejectWithValue}) => {
        
        try{
            const response = await axios.get(`/Order/resetOrder/${id}`,
            {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }
            )
            return response?.data
        } catch (err) {
            console.log(err.response)
            return rejectWithValue(err.response.data.title)
        }
        
    }
)


const getOrderSlice = createSlice({
    name: 'getOrder',
    initialState,
    reducers: {},
    extraReducers:{
        [getOrder.pending]: (state, action) => {
            state.status='pending';
            state.isLoading=true;
        },
        [getOrder.fulfilled]: (state, action) => {
            state.status='success';
            state.isLoading=false;
            state.orderDetails = action.payload;
            // localStorage.setItem('user', JSON.stringify(action.payload))
        },
    
        [getOrder.rejected]: (state, action) => {
            state.status='failed';
            state.isLoading=false;
        }
    }
})

export const getOrderIdSlice = createSlice({
    name: 'getOrderId',
    initialState,
    reducers: {},
    extraReducers:{
        [getOrderId.pending]: (state, action) => {
            state.status='pending';
            state.isLoading=true;
        },
        [getOrderId.fulfilled]: (state, action) => {
            state.status='success';
            state.isLoading=false;
            state.orderDetails = action.payload;
        },
    
        [getOrderId.rejected]: (state, action) => {
            state.status='failed';
            state.isLoading=false;
        }
    }
})
export const cancelOrderSlice = createSlice({
    name: 'cancelOrder',
    initialState,
    reducers: {},
    extraReducers:{
        [cancelOrder.pending]: (state, action) => {
            state.status='pending';
            state.isLoading=true;
        },
        [cancelOrder.fulfilled]: (state, action) => {
            state.status='success';
            state.isLoading=false;
            state.orderDetails = action.payload;
        },
    
        [cancelOrder.rejected]: (state, action) => {
            state.status='failed';
            state.isLoading=false;
        }
    }
})

export default getOrderSlice.reducer;